import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {IWord, IWordAudioTable, IWordAudioEntry} from "../../api/data-model";
import {UtilitiesService} from "../utilities.service";
import {HttpClient} from "@angular/common/http";
import {AudioState} from "../../constants";

export class WordAudioPipelineService {
    private wordAudioTable:IWordAudioTable;

    constructor(public http:HttpClient, private contentLocation:string, private contentServer:string) {
        console.log("clearing audio table");
        this.wordAudioTable = {};
    }

    public loadWordAudioTable():Observable<string> {
        return this.http.get(this.contentServer + "wordAudio" + UtilitiesService.cacheBuster("?"),
            { withCredentials: true }).map((response: any) => {
            console.log("loading audio table");
            // console.log("setting dict to:" + JSON.stringify(response))
            this.wordAudioTable = (response);
            return("OK");
        });
    }

    public postWordAudioTable():Observable<string> {
        return this.http.post(this.contentServer + "wordAudio",
                              JSON.stringify(this.wordAudioTable, null, "\t"),
                              {headers: {"Content-Type": "application/json", "Accept": "application/json"} })
            .map((response: Response) => {
            console.log("posted audio table");
            return("OK");
        });
    }

    public getWordKey(word: IWord):string {
        let key =  word.word.toLowerCase();
        if (word.dictionary) {
            key = word.dictionary[0].toLowerCase();

        }
        return key;
    }

    public getWord(word: IWord):IWordAudioEntry {
        let wordKey: string = this.getWordKey(word);
        return this.wordAudioTable[wordKey];
    }

    public addWordToAudioTable(word: IWord, setAsScripted: boolean): void {
        // key is either text (case-normalized), or recognition text if it exists
        let wordKey: string = this.getWordKey(word);
        let needsReview = false;

        if (word.dictionary) {
            if (word.dictionary.length > 1) {
                needsReview = true;
            }

        }
        // console.log("key for word audio:" + wordKey)
        if (!(wordKey in this.wordAudioTable)) {
            this.wordAudioTable[wordKey] = {audio: []};
            if (needsReview) {
                this.wordAudioTable[wordKey].needsReview = true;
            }
        }
        if (this.wordAudioTable[wordKey].audio.indexOf(word.audio) === -1) {
            this.wordAudioTable[wordKey].audio.push(word.audio);
            if (needsReview) {
                this.wordAudioTable[wordKey].needsReview = true;
            }
        }
        if (setAsScripted) {
            this.wordAudioTable[wordKey].audioState = AudioState.SCRIPTED;
        }

    }

    public getAudioForWord(wordKey: string):string[] {
        return this.wordAudioTable[wordKey] ? this.wordAudioTable[wordKey].audio : [];
    }

    public getAudioStateForWord(wordKey: string):string {
        return this.wordAudioTable[wordKey] ? this.wordAudioTable[wordKey].audioState : null;
    }

    get audioTable():IWordAudioTable {
        console.log("table length: " + Object.keys(this.wordAudioTable).length);
        return this.wordAudioTable;
    }
}
